<script setup>
import i18next from 'i18next';
import { onMounted, ref } from 'vue';

const reportImg = ref('');
const aboveTheFoldText1 = ref('');
const aboveTheFoldText2 = ref('');
const reportText1 = ref('');
const reportText2 = ref('');
let firstRange = false;

const trackBuyNow = (cta_id, cta_position) => {
    localStorage.setItem(
        'hkcm_last_cta',
        JSON.stringify({
            cta_id,
            cta_position,
            ts: Date.now(),
            expires_at: Date.now() + 2 * 24 * 60 * 60 * 1000 // 2 Days
        })
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'cta_sonderberichte_2026',
        cta_id,
        cta_position,
        destination: '/produkte',
        button_text: 'Jetzt buchen',
        lang: i18next.language || 'de'
    });
};

function captureUtm() {
    const p = new URLSearchParams(window.location.search);
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'twclid'];

    const found = {};
    let hasAny = false;

    keys.forEach((k) => {
        const v = p.get(k);

        if (v) {
            found[k] = v;
            hasAny = true;
        }
    });

    if (!hasAny) return;

    // LAST TOUCH: Save if new
    window.localStorage.setItem(
        'hkcm_utm',
        JSON.stringify({
            ...found,
            ts: Date.now(),
            expires_at: Date.now() + 2 * 24 * 60 * 60 * 1000 // 2 Days
        })
    );
}

const toTs = (isoWithOffset) => new Date(isoWithOffset).getTime();

const inRange = (ts, start, end) => ts >= start && ts <= end;

const marketingStatus = () => {
    const now = Date.now();

    firstRange = inRange(now, toTs('2026-01-18T00:00:00+01:00'), toTs('2026-01-28T23:59:59+01:00'));

    const windows = [
        {
            key: 'second',
            start: '2026-01-18T09:00:00+01:00',
            end: '2026-01-24T23:59:59+01:00',
            t1: 'Kommt 2026 der Jahrhundert-Crash? <br> Alle Antworten im Sonderbericht USA (ab 18.01.2026): Deep-Dive zu u. a. S&P 500, Dow Jones, Russell 2000 und US-Titans.',
            t2: 'Die Zukunft der Metalle – die Metalle der Zukunft Alle Insights im Sonderbericht Edelmetalle (ab 18.01.2026): Langfristszenarien für Gold (inkl. GLD), Silber, Platin, Palladium, Uran und Kupfer.',
            t3: '<div class="font-semibold text-white">Sonderbericht Fokus USA:</div><div>Kommt 2026 der Jahrhundert-Crash?</div>',
            t4: '<div class="font-semibold text-white">Sonderbericht Fokus Metalle:</div><div>Die Zukunft der Metalle – die Metalle der Zukunft</div>',
            img: '/hkcm/images/sonderberichtekombi_usa_metalle.png'
        },
        {
            key: 'third',
            start: '2026-01-25T09:00:00+01:00',
            end: '2026-01-31T23:59:59+01:00',
            t1: 'Die große Neubewertung. Alles Insights im Sonderbericht Minen (ab 25.01.): Langfristszenarien zu GDX, GDXJ und Minen-Paket',
            t2: 'Die zweite Welle der grünen Revolution. Alle Antworten im Sonderbericht Cannabis (ab 25.01.): Deep-Dive zu Tilray Brands, Canopy Growth, Aurora Cannabis, Jazz Pharmaceuticals und Cannabis-Aktienpaket.',
            t3: '<div class="font-semibold text-white">Sonderbericht Fokus Minen:</div><div>Die große Neubewertung?</div>',
            t4: '<div class="font-semibold text-white">Sonderbericht Fokus Cannabis:</div><div>Die zweite Welle der grünen Revolution</div>',
            img: '/hkcm/images/sonderberichtekombi_minen_cannabis.jpg'
        },
        {
            key: 'fourth',
            start: '2026-02-01T09:00:00+01:00',
            end: '2026-02-07T23:59:59+01:00',
            t1: 'Leben und  Sterben der Weltmacht USA. Alle Antworten im Sonderbericht Energie (ab 01.02.): Deep-Dive zu Erdgas (Natgas & BOIL), Rohöl (Brent, WTI, OIH, USO)',
            t2: 'Die Rückkehr zur Marktbreite. Alle Insights im Sonderbericht Technologie (ab 01.02.): Langfristszenarien zu NQ, Block, Snowflake, Cloudflare, Paypal, Shopify',
            t3: '<div class="font-semibold text-white">Sonderbericht Fokus Energie:</div><div>Leben und Sterben der Weltmacht USA</div>',
            t4: '<div class="font-semibold text-white">Sonderbericht Fokus Technologie:</div><div>Die Rückkehr zur Marktbreite</div>',
            img: '/hkcm/images/sonderberichtekombi_energie_technologie.jpg'
        },
        {
            key: 'fifth',
            start: '2026-02-08T09:00:00+01:00',
            end: '2026-02-14T23:59:59+01:00',
            t1: 'Zwischen Modernisierungsschub und strukturellem Gegenwind. Alle Insights im Sonderbericht China (ab 08.02.): Langfristszenarien zu Hang Seng Index, Shanghai Stock Exchange-Index (SSE Composite), XPeng, NetEase',
            t2: 'Europa und der Stier. Alle Antworten im Sonderbericht Europa (ab 08.02.): Deep-Dive zu Dax-Index, MDax-Index & Rheinmetall, Mercedes, Allianz, LVMH',
            t3: '<div class="font-semibold text-white">Sonderbericht Fokus China:</div><div>Zwischen Modernisierungsschub und strukturellem Gegenwind</div>',
            t4: '<div class="font-semibold text-white">Sonderbericht Fokus Europa:</div><div>Europa und der Stier</div>',
            img: '/hkcm/images/sonderberichtekombi_china_europa.jpg'
        },
        {
            key: 'sixth',
            start: '2026-02-15T09:00:00+01:00',
            end: '2026-02-21T23:59:59+01:00',
            t1: 'Der Preis des Fortschritts. Alle Antworten im Sonderbericht KI (ab 15.02.): Deep-Dive zu Palantir, Nvidia, Tesla, Meta, TSMC',
            t2: 'Das Ende des Kryptomarktes (wie wir ihn kennen). Alle Insights im Sonderbericht Kryptowährungen  (ab 15.02.): Langfristszenarien zu BTC/ETH, Altcoins',
            t3: '<div class="font-semibold text-white">Sonderbericht Fokus KI:</div><div>Der Preis des Fortschritts</div>',
            t4: '<div class="font-semibold text-white">Sonderbericht Fokus Kryptowährungen:</div><div>Das Ende des Kryptomarktes (wie wir ihn kennen)</div>',
            img: '/hkcm/images/sonderberichtekombi_ki_kryptowahrungen.jpg'
        }
    ];

    const active = windows.find((w) => inRange(now, toTs(w.start), toTs(w.end)));

    if (active) {
        reportText1.value = active.t1;
        reportText2.value = active.t2;
        aboveTheFoldText1.value = active.t3;
        aboveTheFoldText2.value = active.t4;
        reportImg.value = active.img;
    }
};

onMounted(() => {
    captureUtm();

    marketingStatus();
});
</script>

<template>
    <header
        class="absolute border-b-2 border-[#353CEE] bg-[#0A0E27] top-0 left-0 right-0 z-20 flex items-center justify-between px-6 py-4 shadow-[38px_13px_22px_6px_rgba(53,60,238,0.1)]"
    >
        <div class="shrink-0">
            <img class="h-10 w-auto lg:h-12" :src="$asset('/hkcm/images/logo-on-dark-background.svg', 'public')" alt="HKCM Logo" title="HKCM Logo" />
        </div>

        <div class="flex flex-col md:flex-row items-center md:gap-8">
            <div class="hidden md:flex flex-col items-end">
                <small class="text-white">
                    {{ $t('homepage_cooperation') }}
                </small>

                <div class="mt-2 flex items-center gap-6">
                    <img alt="Thomson Reuters" class="h-4 w-auto object-contain lg:h-5" :src="$asset('/hkcm/images/partners/thomson-reuters-light.png', 'public')" />
                    <img alt="S&amp;P Global" class="h-4 w-auto object-contain lg:h-5" :src="$asset('/hkcm/images/partners/sup-global.png', 'public')" />
                </div>
            </div>

            <div class="flex items-center gap-4 lg:gap-6">
                <img
                    alt="Black Bull Krypto Insider"
                    class="w-16 h-auto object-contain lg:h-16 rounded-full md:block hidden"
                    :src="$asset('/hkcm/images/BlackBull24_Krypto_rounded.png', 'public')"
                />
                <img
                    alt="Black Bull Investment Visionär"
                    class="h-16 w-auto object-contain lg:h-16 rounded-full"
                    :src="$asset('/hkcm/images/partners/BlackBull25_InvestmentVision.png', 'public')"
                />
                <img
                    alt="DISQ Trust Siegel"
                    class="h-16 w-auto object-contain lg:h-16 md:block"
                    :src="
                        $asset(
                            i18next.language === 'de'
                                ? '/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM.png'
                                : '/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM_global.png',
                            'public'
                        )
                    "
                />
            </div>
        </div>
    </header>
    <div class="bg-[#010e22] pt-24 overflow-hidden">
        <section class="w-full py-16">
            <h1 class="mx-auto max-w-7xl px-6 mb-4 text-4xl font-extrabold leading-tight text-white md:text-5xl text-center block md:hidden">
                DIE EXKLUSIVEN HKCM-SONDERBERICHTE 2026
            </h1>
            <img :src="$asset('/hkcm/images/sonderberichte-bg.png', 'public')" alt="HKCM Special Reports Landing Page" class="absolute top-[-200px] w-full h-auto" />
            <div class="mx-auto max-w-7xl px-6 relative z-10">
                <div class="flex flex-col-reverse md:grid gap-12 md:grid-cols-2 md:items-start">
                    <div>
                        <h1 class="md:block hidden text-4xl font-extrabold leading-tight text-white md:text-5xl">
                            DIE EXKLUSIVEN HKCM-<br />
                            SONDERBERICHTE 2026
                        </h1>

                        <p class="md:mt-5 text-lg font-semibold leading-snug text-white">
                            Up to date. Die wichtigsten Märkte.<br />
                            Alles für ihren finanziellen Vorteil.
                        </p>

                        <div class="mt-8 space-y-5 text-sm leading-relaxed text-white">
                            <div v-html="aboveTheFoldText1"></div>
                            <div v-html="aboveTheFoldText2"></div>
                        </div>

                        <div class="md:block hidden mt-10 animate-pulse">
                            <router-link
                                to="/produkte"
                                class="inline-flex items-center gap-3 rounded-full bg-[#F5E55B] px-8 py-3 text-sm font-semibold text-black shadow-[0_10px_30px_rgba(245,229,91,0.25)] transition hover:brightness-105"
                                @click="trackBuyNow('lp_sonderberichte_2026_btn_1', 'area_video')"
                            >
                                Jetzt buchen
                                <span class="text-lg leading-none">→</span>
                            </router-link>
                        </div>
                    </div>

                    <div class="relative">
                        <div class="relative overflow-hidden rounded-2xl border-2 border-[#353CEE]">
                            <iframe
                                width="100%"
                                height="315"
                                src="https://www.youtube.com/embed/rIjPTfCcuV0?si=dKxZ5RoVmfeYBVrl&enablejsapi=1&origin=https://hkcmanagement.de"
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin"
                                allowfullscreen
                            ></iframe>
                        </div>

                        <div v-if="firstRange" class="mt-6 rounded-xl border-2 border-[#F5E55B]/90 bg-[#0B1224]/40 px-6 py-4 text-center text-sm text-white">
                            <span class="font-semibold text-white">Exklusiv:</span>
                            20% Rabatt auf alle Produkte mit <span class="font-semibold text-white">Rabattcode REPORT2026</span><br />
                            Einfach beim Checkout eingeben und Vorteile genießen.
                        </div>
                        <div class="block md:hidden mt-10 animate-pulse">
                            <router-link
                                to="/produkte"
                                class="inline-flex items-center gap-3 rounded-full bg-[#F5E55B] px-8 py-3 text-sm font-semibold text-black shadow-[0_10px_30px_rgba(245,229,91,0.25)] transition hover:brightness-105"
                                @click="trackBuyNow('lp_sonderberichte_2026_btn_1', 'area_video')"
                            >
                                Jetzt buchen
                                <span class="text-lg leading-none">→</span>
                            </router-link>
                        </div>
                    </div>
                </div>

                <router-link to="#sonderberichte2026">
                    <div class="mt-10 flex justify-center animate-bounce">
                        <div class="grid place-items-center">
                            <div class="h-10 w-10 rotate-45 border-b-4 border-r-4 border-[#2D3CFF]"></div>
                            <div class="-mt-4 h-10 w-10 rotate-45 border-b-4 border-r-4 border-[#2D3CFF]/70"></div>
                        </div>
                    </div>
                </router-link>
            </div>
        </section>

        <section class="w-full py-16 relative">
            <img :src="$asset('/hkcm/images/sonderberichte-bg.png', 'public')" alt="HKCM Special Reports Landing Page" class="absolute z-0 top-[-150px] w-full h-auto" />

            <div id="sonderberichte2026" class="mx-auto max-w-7xl px-6 relative z-10">
                <div class="flex flex-col-reverse md:grid gap-12 md:grid-cols-2 md:items-start">
                    <!-- LEFT COLUMN -->
                    <div class="space-y-6">
                        <!-- Top image card -->
                        <div class="overflow-hidden rounded-2xl border-2 border-[#2D3CFF]">
                            <img :src="$asset(reportImg, 'public')" alt="Sonderberichte 2026" class="h-full w-full object-contain" />
                        </div>

                        <!-- Chart placeholder -->
                        <div class="overflow-hidden rounded-2xl border-2 border-[#2D3CFF]">
                            <img :src="$asset('/hkcm/images/exampleChart.png', 'public')" alt="Analyse Chart" class="h-full w-full object-contain opacity-80" />
                        </div>

                        <!-- Discount box -->
                        <div v-if="firstRange" class="rounded-xl border-2 border-[#F5E55B]/90 bg-[#0B1224]/40 px-6 py-5 text-center text-sm text-white">
                            <span class="font-semibold text-white">Exklusiv:</span>
                            20% Rabatt auf alle Produkte mit
                            <span class="font-semibold text-white">Rabattcode REPORT2026</span><br />
                            Einfach beim Checkout eingeben und Vorteile genießen.
                        </div>
                    </div>

                    <!-- RIGHT COLUMN -->
                    <div>
                        <h2 class="text-3xl font-extrabold leading-tight text-white md:text-4xl">
                            Die Sonderberichte 2026:<br />
                            Gebündeltes Finanzwissen<br />
                            zu ihrem Vorteil
                        </h2>

                        <ul class="mt-6 space-y-4 text-sm leading-relaxed text-white list-disc">
                            <li>
                                <p v-html="reportText1" />
                            </li>

                            <li>
                                <p v-html="reportText2" />
                            </li>

                            <li>
                                Wir liefern das große Bild, damit Sie verstehen, was Märkte treibt,
                                <span class="font-semibold">bevor</span> Sie Entscheidungen treffen.
                            </li>

                            <li>
                                Lesen Sie <span class="font-semibold">alle Sonderberichte</span> zu <span class="font-semibold">allen Märkten</span> direkt in Ihrem
                                <span class="font-semibold">HKCM Dashboard</span> – jederzeit abrufbar, klar strukturiert und sofort verfügbar.
                            </li>

                            <li>Jahresrückblick + wissenschaftliche Einordnung + Tiefenanalyse = echte Orientierung für Sie.</li>

                            <li>
                                Wir decken das gesamte HKCM-Analyse-Universum ab:
                                <span class="font-semibold"> über 200 Assets</span> aus <span class="font-semibold">über 190 Märkten</span> in den Bereichen
                                <span class="font-semibold">Aktien, Indizes, Krypto</span>
                                und <span class="font-semibold">Rohstoffe.</span>
                            </li>

                            <li>
                                Sie erhalten
                                <span class="font-semibold">alle </span>Sonderberichte 2026 ab nur einem Produktkauf – egal wann Sie es kaufen.
                            </li>
                        </ul>

                        <!-- CTA -->
                        <div class="mt-8 text-center md:text-left animate-pulse">
                            <router-link
                                to="/produkte"
                                class="inline-flex items-center gap-3 rounded-full bg-[#F5E55B] px-8 py-3 text-sm font-semibold text-black shadow-[0_10px_30px_rgba(245,229,91,0.25)] transition hover:brightness-105"
                                @click="trackBuyNow('lp_sonderberichte_2026_btn_2', 'area_finanzwissen')"
                            >
                                Jetzt buchen
                                <span class="text-lg leading-none">→</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="md:py-16 relative">
            <img :src="$asset('/hkcm/images/sonderberichte-bg2.png', 'public')" alt="HKCM Special Reports Landing Page" class="absolute top-[-100px] w-full h-auto" />

            <div class="mx-auto w-full max-w-7xl px-4 sm:px-6 relative z-10">
                <div class="text-center">
                    <h2 class="text-2xl sm:text-3xl md:text-4xl font-semibold leading-tight text-white">Unsere Sonderberichte:</h2>
                    <p class="mt-2 text-xl sm:text-2xl md:text-3xl font-semibold leading-tight text-white">
                        voller Zugang zu
                        <span class="underline decoration-white/80 underline-offset-4">allen Berichten</span>
                        <span class="hidden sm:inline"><br /></span>
                        <span class="sm:ml-1"> schon ab einer Buchung</span>
                    </p>
                </div>

                <!-- Timeline -->
                <div class="mt-8 sm:mt-10">
                    <!-- Mobile: horizontal scroll (no squishing) -->
                    <div class="-mx-4 mx-4 sm:mx-0 sm:px-0 overflow-x-auto">
                        <div class="min-w-[820px]">
                            <!-- Dates row -->
                            <div class="grid grid-cols-5 gap-6">
                                <div class="flex justify-center">
                                    <div
                                        class="rounded-md border border-[#2D3CFF]/90 bg-[#070D22] px-4 sm:px-5 py-2 text-xs sm:text-sm font-medium text-white shadow-[0_0_0_2px_rgba(45,60,255,0.25)]"
                                    >
                                        18.01.2026
                                    </div>
                                </div>

                                <div class="flex justify-center">
                                    <div
                                        class="rounded-md border border-[#2D3CFF]/90 bg-[#070D22] px-4 sm:px-5 py-2 text-xs sm:text-sm font-medium text-white shadow-[0_0_0_2px_rgba(45,60,255,0.25)]"
                                    >
                                        25.01.2026
                                    </div>
                                </div>

                                <div class="flex justify-center">
                                    <div
                                        class="rounded-md border border-[#2D3CFF]/90 bg-[#070D22] px-4 sm:px-5 py-2 text-xs sm:text-sm font-medium text-white shadow-[0_0_0_2px_rgba(45,60,255,0.25)]"
                                    >
                                        01.02.2026
                                    </div>
                                </div>

                                <div class="flex justify-center">
                                    <div
                                        class="rounded-md border border-[#2D3CFF]/90 bg-[#070D22] px-4 sm:px-5 py-2 text-xs sm:text-sm font-medium text-white shadow-[0_0_0_2px_rgba(45,60,255,0.25)]"
                                    >
                                        08.02.2026
                                    </div>
                                </div>

                                <div class="flex justify-center">
                                    <div
                                        class="rounded-md border border-[#2D3CFF]/90 bg-[#070D22] px-4 sm:px-5 py-2 text-xs sm:text-sm font-medium text-white shadow-[0_0_0_2px_rgba(45,60,255,0.25)]"
                                    >
                                        15.02.2026
                                    </div>
                                </div>
                            </div>

                            <!-- Line + nodes -->
                            <div class="relative mt-6 sm:mt-8">
                                <div class="mx-auto h-[6px] w-[86%] rounded-full bg-[#2D3CFF]"></div>

                                <div class="absolute inset-0 flex items-center">
                                    <div class="mx-auto w-full px-6">
                                        <div class="grid grid-cols-5 gap-6">
                                            <div class="flex justify-center">
                                                <div class="h-4 w-4 sm:h-5 sm:w-5 rounded-full bg-[#2D3CFF] shadow-[0_0_0_8px_rgba(45,60,255,0.15)]"></div>
                                            </div>
                                            <div class="flex justify-center">
                                                <div class="h-4 w-4 sm:h-5 sm:w-5 rounded-full bg-[#2D3CFF] shadow-[0_0_0_8px_rgba(45,60,255,0.15)]"></div>
                                            </div>
                                            <div class="flex justify-center">
                                                <div class="h-4 w-4 sm:h-5 sm:w-5 rounded-full bg-[#2D3CFF] shadow-[0_0_0_8px_rgba(45,60,255,0.15)]"></div>
                                            </div>
                                            <div class="flex justify-center">
                                                <div class="h-4 w-4 sm:h-5 sm:w-5 rounded-full bg-[#2D3CFF] shadow-[0_0_0_8px_rgba(45,60,255,0.15)]"></div>
                                            </div>
                                            <div class="flex justify-center">
                                                <div class="h-4 w-4 sm:h-5 sm:w-5 rounded-full bg-[#2D3CFF] shadow-[0_0_0_8px_rgba(45,60,255,0.15)]"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Labels row -->
                            <div class="pb-4 mt-6 sm:mt-8 grid grid-cols-5 gap-6 text-center text-xs sm:text-sm font-medium text-white/90 tracking-[0.16em]">
                                <div>
                                    USA &<br />
                                    METALLE
                                </div>
                                <div>
                                    MINEN &<br />
                                    CANNABIS
                                </div>
                                <div>
                                    ENERGIE &<br />
                                    TECHNOLOGIE
                                </div>
                                <div>
                                    CHINA &<br />
                                    EUROPA
                                </div>
                                <div>
                                    KI &<br />
                                    KRYPTOWÄHRUNG
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Optional: hint that it's scrollable on mobile -->
                    <div class="mt-4 text-center text-xs text-white/50 md:hidden">Wischen, um die Timeline zu sehen →</div>
                </div>
            </div>
        </section>

        <section class="w-full py-14 relative z-10">
            <div class="mx-auto w-full max-w-7xl px-6">
                <div class="text-center">
                    <h1 class="py-5 md:py-0 text-4xl font-extrabold leading-tight text-white md:text-6xl">
                        Über 70% Trefferquote<br />
                        auf alle Tradingbereiche
                    </h1>
                </div>

                <div class="md:mt-12 flex flex-col-reverse md:grid gap-16 md:grid-cols-2 md:items-start">
                    <div>
                        <h2 class="text-xl font-bold text-white md:text-2xl">
                            Wir sind die #1 in Deutschland,<br />
                            wenn es um Finanzanalysen geht
                        </h2>

                        <div class="mt-6 space-y-5 text-sm leading-relaxed text-white">
                            <p>
                                <span class="font-semibold text-white">HKCM</span> ist das <span class="font-semibold text-white">führende Finanzanalysehaus</span> im
                                deutschsprachigem Raum.
                            </p>

                            <p>
                                Wir decken alle wichtigen <span class="font-semibold text-white">Finanzbereiche</span> ab und definieren
                                <span class="font-semibold text-white">Einstiegsbereiche</span> und <span class="font-semibold text-white">Zielzonen</span>, um Ihnen die
                                Handelsentscheidungen zu erleichtern.
                            </p>

                            <p>
                                Insgesamt bieten wir Ihnen Analysen zu <span class="font-semibold text-white">über 190 Märkten</span> an: Von
                                <span class="font-semibold text-white">Aktien</span> und <span class="font-semibold text-white">Indizes</span> zu
                                <span class="font-semibold text-white">Krypto</span> und <span class="font-semibold text-white">Rohstoffe</span>.
                            </p>

                            <p>
                                Mehrfach ausgezeichnet mit dem Black Bull Award ist HKCM das
                                <span class="font-semibold text-white">Powerhaus der Finanzanalyse</span> in Deutschland.
                            </p>
                        </div>

                        <div class="mt-8 animate-pulse">
                            <router-link
                                to="/produkte"
                                class="inline-flex items-center gap-3 rounded-full bg-[#F5E55B] px-8 py-3 text-sm font-semibold text-[#0B1224] shadow-[0_10px_30px_rgba(245,229,91,0.25)] transition hover:brightness-105"
                                @click="trackBuyNow('lp_sonderberichte_2026_btn_3', 'area_trefferquote')"
                            >
                                Jetzt buchen
                                <span class="text-lg leading-none">→</span>
                            </router-link>
                        </div>
                    </div>

                    <div class="relative">
                        <div class="relative">
                            <img
                                :src="$asset('/hkcm/images/ph_ihre_finazielle_freiheit.png', 'public')"
                                alt="Event / Vortrag"
                                class="h-[200px] w-full object-contain md:h-[360px] rounded-2xl"
                            />
                            <div
                                class="absolute bottom-1 md:left-[-50px] flex h-24 w-24 items-center justify-center rounded-full bg-white shadow-[0_18px_40px_rgba(0,0,0,0.35)] md:-bottom-6 md:h-28 md:w-28"
                            >
                                <img
                                    alt="Black Bull Investment Visionär"
                                    class="object-cover max-h-[180px] w-auto rounded-full"
                                    :src="$asset('/hkcm/images/partners/BlackBull25_InvestmentVision.png', 'public')"
                                />
                            </div>
                        </div>
                        <div class="md:mt-3 text-right text-[11px] text-white">Philip Hopf auf der Cashflow Conference 2025</div>

                        <div v-if="firstRange" class="mt-4 rounded-xl border-2 border-[#F5E55B]/85 bg-[#0B1224]/35 px-5 py-4 text-center text-sm text-white">
                            <span class="font-semibold text-white">Exklusiv:</span>
                            20% Rabatt auf alle Produkte mit <span class="font-semibold text-white">Rabattcode REPORT2026</span><br />
                            Einfach beim Checkout eingeben und Vorteile genießen.
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="w-full py-10 relative">
            <img :src="$asset('/hkcm/images/sonderberichte-bg2.png', 'public')" alt="HKCM Special Reports Landing Page" class="absolute right-[0px] top-[-100px] w-full h-auto" />

            <div class="mx-auto max-w-7xl px-6 relative z-10">
                <div class="flex flex-col items-start gap-16 rounded-2xl border-2 border-[#2D3CFF] px-8 py-7 md:flex-row md:items-center">
                    <div class="w-full md:max-w-3xl text-white">
                        <p class="text-xl font-bold leading-snug md:text-2xl md:w-[70%]">
                            Unser Ziel:<br />
                            Ihre finanzielle Freiheit! Schon ein Analyse-Produkt sichert ihnen<br />
                            <span class="underline">alle HKCM-Sonderberichte 2026</span>.
                        </p>
                    </div>

                    <router-link
                        to="/produkte"
                        class="animate-pulse inline-flex items-center gap-3 rounded-full bg-[#F5E55B] px-8 py-3 text-sm font-semibold text-black shadow-[0_10px_30px_rgba(245,229,91,0.25)] transition hover:brightness-105"
                        @click="trackBuyNow('lp_sonderberichte_2026_btn_4', 'area_finanzielle_freiheit')"
                    >
                        Jetzt buchen
                        <span class="text-lg leading-none">→</span>
                    </router-link>
                </div>
            </div>
        </section>
    </div>
    <footer class="border-t-2 border-[#353CEE] bg-[#010e22] relative z-10 px-2">
        <div class="mx-auto max-w-7xl w-full py-10 flex justify-between flex-row">
            <img class="w-20 h-auto" :src="$asset('/hkcm/images/logo-on-dark-background.svg', 'public')" alt="HKCM Logo" title="HKCM Logo" />
            <div class="flex gap-2 lg:gap-32">
                <router-link class="underline text-white" to="/impressum">Impressum</router-link>
                <router-link class="underline text-white" to="/datenschutz">Datenschutz</router-link>
                <router-link class="underline text-white" to="/agb">AGBs</router-link>
            </div>
        </div>
    </footer>
</template>

<style scoped></style>
